import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Space, Table, Tag, Modal } from "antd";
import { CreditCardTwoTone } from "@ant-design/icons";

import SettingSidebar from "../SettingSidebar/SettingSidebar";
import { getUserDetails } from "../../../../../redux/actions/user";
import { getOrders, cancelSubscription } from "../../../../../redux/actions/payment";
import { changeActiveTab } from "../../../../../redux/actions/skill";
import $ from "jquery"

const Billing = () => {
  const [tableData, setTabledata] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.userReducer.user);
  const details = useSelector((state) => state.userReducer.details);
  const orders = useSelector((state) => state.paymentReducer.orders);
  const groupPlan = useSelector((state) => state.userReducer.groupPlan);
  const currentActiveTab = useSelector((state) => state.skillReducer.isActive);
  const cancelPlanResponse = useSelector((state) => state.paymentReducer.cancelSubscription);
  const isMinMode = useSelector((state) => state.appReducer.minmode);
  const [cancelModalLoading, setCancelModalLoading] = useState(false)
  const [userType, setUserType] = useState(null);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const checkoutPlan = (planId, context) => {
    if(context == 'add') {
      history.push(`/checkout?p=${planId}&c=a`);
    }
    else if (userType !== "free") {
      history.push(`/pricing`);
    } else {
      history.push(`/pricing`);
      dispatch(changeActiveTab("Pricing"));
    }
  };

  const columns = [
    {
      title: <div style={{ fontSize: 12, fontWeight: 500 }}> Date</div>,
      dataIndex: "date",
      key: "date",
      render: (text) => (
        <div style={{ fontSize: 12, fontWeight: 100 }}>
          {new Date(text).toDateString()}
        </div>
      ),
    },
    {
      title: <div style={{ fontSize: 12, fontWeight: 500 }}> Amount</div>,
      dataIndex: "amount",
      key: "amount",
      render: (text) => (
        <div style={{ fontSize: 12, fontWeight: 100 }}>${text}</div>
      ),
    },
    {
      title: <div style={{ fontSize: 12, fontWeight: 500 }}> Plan</div>,
      dataIndex: "plan",
      key: "plan",
      render: (text) => (
        <div style={{ fontSize: 12, fontWeight: 100 }}>{text}</div>
      ),
    },
    {
      title: <div style={{ fontSize: 12, fontWeight: 500 }}> Status</div>,
      key: "status",
      dataIndex: "status",
      render: (_, { tags }) => (
        <>
          {tags.map((tag) => {
            let color = tag.length > 5 ? "#02ce9d" : "#02ce9d";
            if (tag === "loser") {
              color = "#ff3333";
            }
            return (
              <Tag
                color={color}
                key={tag}
                style={{ borderRadius: 3, fontSize: 10 }}
              >
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: <div style={{ fontSize: 12, fontWeight: 500 }}> Invoice</div>,
      key: "action",
      render: (_, { action }) => (
        <Space size="middle">
          <a
            className="btn btn-default btn-default-download"
            target="_blank"
            rel="noopener noreferrer"
            href={`${process.env.REACT_APP_BOT_SERVICE_URL}/payment/invoice/download/${action?.invoiceId}`}
            style={{ fontSize: "12px" }}
          >
            Download
          </a>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    if (user) {
      dispatch(getUserDetails(user.sub));
    }
  }, [user]);

  useEffect(() => {
    setUserType(groupPlan?.type);
  }, [groupPlan]);

  useEffect(() => {
    dispatch(getOrders());
  }, []);

  useEffect(() => {
    if(cancelPlanResponse) {
      setShowCancelModal(false)
      setCancelModalLoading(false)
      window.location.reload()
    }
  },[cancelPlanResponse])

  useEffect(() => {
    let _data = orders.map((i, index) => {
      return {
        key: index,
        date: i?.createdAt,
        amount: i?.price,
        plan: i?.lineItems[0]?.plan.name,
        tags: ["paid"],
        action: i?.metaData,
      };
    });

    setTabledata(_data);
  }, [orders]);

  useEffect(() => {
    $('.fixed-bar').removeClass('active');
  });     
  
  const handleSidebarClose = () => {
    const childElements = document.querySelectorAll('.inner-left-sidebar');
  
    // Remove the 'active' class from each child element
    childElements.forEach(element => {
      element.classList.remove('active');
    })
  };

  const cancelPlan = () => {
    setCancelModalLoading(true)
    dispatch(cancelSubscription())
  } 

  return (
    <div className="d-flex">
      <Modal
        title="Cancel Subscription"
        open={showCancelModal}
        confirmLoading={cancelModalLoading}
        onCancel={() => setShowCancelModal(false)}
        onOk={() => cancelPlan()}
        okText= "Proceed"
        cancelText= "Don't Cancel"
      >
        <p>
          Your current subscription will canceled at the end of current billing
          term
        </p>
      </Modal>

      <div className="inner-left-sidebar">
          <div className="px-4 pt-4">
          <button className="close drawer-close-btn" onClick={handleSidebarClose}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-x-circle">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
              </svg> 
            </button>
            <h5 className="mb-0">Settings</h5>
          </div>
          <SettingSidebar />
        </div>

      <div className="inner-right bg-grey">
        <div className="template-flex">
          <div className="template-box scrollable">
            <div class="tp-title flex-title">
              <h4>Subscription</h4>
            </div>
            <div className="subs-bg">
              <div className="subs-block">
                <h4 className="subs-m-title"> Current Plan </h4>
                <div className="subs-inner-bg">
                  <div className="subs-plan">
                    {groupPlan?.plan?.id == 3 ? <span className={`plan-badge Pro`}>Pro</span> : null}
                    {groupPlan?.plan?.id == 4 ? <span className={`plan-badge Team`}>Team</span> : null}
                    {groupPlan?.plan?.id == 5 ? <span className={`plan-badge Business`}>Business</span> : null}
                    <h4>
                      ${groupPlan?.plan?.price} &nbsp;
                      {groupPlan?.plan?.billingCycle == "monthly"
                        ? "per month"
                        : "per year"}
                    </h4>
                    {groupPlan?.plan?.id == 3 ? <p>Everything you need to automate individual work</p> : null}
                    {groupPlan?.plan?.id == 4 ? <p>Acheive faster by collaborating with your team</p> : null}
                    {groupPlan?.plan?.id == 5 ? <p>Scale with your internal & external stakeholders</p> : null}
                    <div className="subs-p-data">
                      <p>
                        {groupPlan?.remarks == 'subscription-cancelled' ? "Plan stops on" : "Plan renews on"}  
                        <br />
                        <span>
                        {groupPlan?.type != "free" ?
                        (groupPlan?.expiryAt
                          ? `${new Date(
                              groupPlan?.expiryAt
                            ).toDateString()}`
                          : null)
                          : "-"}
                        </span>
                      </p>
                    </div>
                    <div className="subs-p-data">
                      <p>User licenses purchased: <strong>{groupPlan?.type != "free" ? groupPlan?.licenseCount : "-"}</strong></p>
                      <p>Available user licenses: <strong>{groupPlan?.type != "free" ? groupPlan?.availableLicenseCount : "-"}</strong></p>
                      <p>Available skill executions: <strong>{groupPlan?.features?.automations}</strong></p>
                    </div>
                  </div>

                  <div className="subs-btn">
                    <Button
                      type="primary"
                      className={
                        isMinMode
                          ? "btn btn-primary"
                          : `btn btn-primary ${
                              currentActiveTab === "Pricing" ? "active" : ""
                            }`
                      }
                      onClick={() => {
                        checkoutPlan(groupPlan?.plan?.id, 'change');
                      }}
                    >
                      {userType == "free" ? "Purchase Plan" : "Change Plan"}
                    </Button>


                    {userType && userType !== "free" ?
                    <Button
                      type="primary"
                      className={
                        isMinMode
                          ? "btn btn-primary"
                          : `btn btn-primary ${
                              currentActiveTab === "Pricing" ? "active" : ""
                            }`
                      }
                      onClick={() => {
                        checkoutPlan(groupPlan?.plan?.id, "add");
                      }}
                    >
                     Add Users
                    </Button> : null }

                    {userType && userType !== "free" ? (
                      <Button
                        className="btn btn-outline"
                        onClick={() => setShowCancelModal(true)}
                      >
                        Cancel Plan
                      </Button>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="subs-block">
                <h4 className="subs-m-title">Payment Method</h4>
                <div className="row cards-slider">
                  <div className="col-md-3 card-box">
                    <div className="card-inner-box">
                      <div className="card-box-icon">
                        <div className="card-icon-round">
                          <CreditCardTwoTone />
                        </div>
                        {details?.card?.brand.toUpperCase()}
                      </div>
                      {details?.card?.last4 ?
                      <h4>**** **** **** {details?.card?.last4}</h4>
                    : <h4>**** **** **** ****</h4>}
                      <span>
                      {details?.card?.exp_month}/
                        {details?.card?.exp_year}
                      </span>
                    </div>
                   
                  </div>
                </div>

                  {/* <div style={{ flex: 0.6 }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                ></div>
              </div> */}
                </div>
              </div>

              <div className="subs-block">
                <h4 className="subs-m-title">Billing Address</h4>
                {groupPlan?.type != "free" ?
                <div>
                  <div>
                    <div>
                      <div className="address-block">
                        <div className="subs-p-data">
                          <p>{details?.billingAddress?.line1}</p>
                          <p>
                            {details?.billingAddress?.city}
                            {details?.billingAddress?.postal_code}
                          </p>
                          <p>{details?.billingAddress?.state}</p>
                          <p>{details?.billingAddress?.country}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div style={{ flex: 0.3 }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "end",
                  }}
                ></div>
              </div> */}
                </div>
                : '-'}
              </div>

              <div className="subs-block">
                <h4 className="subs-m-title"> Billing Information </h4>
                <Table
                  columns={columns}
                  dataSource={tableData}
                  style={{ marginTop: 30 }}
                  pagination={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};
export default Billing;
